/**
 * 批量导出api配置
 * @param ctx
 * @returns {*}
 */
const requireAll = ctx =>
  ctx
    .keys()
    .map(c => ({
      name: c.replace(/^\.\/([a-zA-Z_]+)\.api\.js$/, '$1'),
      value: ctx(c)
    }))
    .reduce((acc, { name, value }) => {
      // eslint-disable-next-line new-cap
      acc[name] = new value.default()
      return acc
    }, {})

export default requireAll(require.context('./modules', false, /\.api\.js$/))
